<cipo-dialog-header
    [fullScreen]="'never'"
    testId="nutrient-doc-link-dialog"
    [title]="isAddAssociation ? 'pdfMarkups.docLink.addTitle' : 'pdfMarkups.docLink.title'" />

<mat-dialog-content>
    @if (errorMessage()) {
        <p role="alert" class="cipo-color--warn">{{ errorMessage() | translate }}</p>
    }
    @if (isAddAssociation) {
        <!-- ADD MODE: form with Document Type + Document selects -->
        @if (isLoading()) {
            <ngx-skeleton-loader [theme]="{ width: '40%', height: '20px', margin: '0 0 16px 0' }" />
        } @else {
            <p class="m-b">{{ message() | translate }}</p>
        }
        <div fxLayout="row" fxLayoutGap="16px" class="p-t">
            @if (isLoading()) {
                <ngx-skeleton-loader fxFlex [theme]="{ width: '100%', height: '56px', margin: '0' }" />
                <ngx-skeleton-loader fxFlex [theme]="{ width: '100%', height: '56px', margin: '0' }" />
            } @else {
                <cipo-select
                    cipoAutofocus
                    fxFlex
                    data-testid="nutrient-doc-link-type-select"
                    [control]="moduleTypeControl"
                    [fieldData]="moduleTypeFieldData()" />
                @if (isLoadingDocs()) {
                    <ngx-skeleton-loader fxFlex [theme]="{ width: '100%', height: '56px', margin: '0' }" />
                } @else {
                    <cipo-select
                        fxFlex
                        data-testid="nutrient-doc-link-document-select"
                        [control]="documentControl"
                        [fieldData]="documentFieldData()" />
                }
            }
        </div>
    } @else {
        <!-- VIEW MODE: list of existing linked documents -->
        @if (isLoading()) {
            <div
                fxLayout="column"
                fxLayoutGap="8px"
                class="p-t"
                role="status"
                [attr.aria-busy]="true"
                [attr.aria-label]="'a11y.pdfMarkups.loading' | translate">
                @for (_ of [1, 2, 3]; track $index) {
                    <ngx-skeleton-loader [theme]="{ width: '100%', height: '32px', margin: '0' }" />
                }
            </div>
        } @else if (associations().length === 0) {
            <p class="p-t" data-testid="nutrient-doc-link-empty">{{ "pdfMarkups.docLink.noDocs" | translate }}</p>
        } @else {
            <table mat-table [dataSource]="associations()" class="cipo--width--full">
                <ng-container matColumnDef="name">
                    <th mat-header-cell *matHeaderCellDef>{{ "pdfMarkups.docTable.name" | translate }}</th>
                    <td mat-cell *matCellDef="let row">
                        @if (row.confirmDeletion && data.canDelete) {
                            {{ "pdfMarkups.docLink.confirmDelete" | translate }}
                            <strong>{{ row.name }}</strong>
                            ?
                        } @else {
                            {{ row.name }}
                        }
                    </td>
                </ng-container>

                <ng-container matColumnDef="createdBy">
                    <th mat-header-cell *matHeaderCellDef>{{ "pdfMarkups.docTable.createdBy" | translate }}</th>
                    <td mat-cell *matCellDef="let row">{{ row.confirmDeletion ? "" : row.createdBy }}</td>
                </ng-container>

                <ng-container matColumnDef="createdOn">
                    <th mat-header-cell *matHeaderCellDef>{{ "pdfMarkups.docTable.createdOn" | translate }}</th>
                    <td mat-cell *matCellDef="let row">{{ row.confirmDeletion ? "" : (row.createdOn | date) }}</td>
                </ng-container>

                <ng-container matColumnDef="actions" stickyEnd>
                    <th mat-header-cell *matHeaderCellDef></th>
                    <td mat-cell *matCellDef="let row" style="text-align: right; white-space: nowrap">
                        @if (row.confirmDeletion) {
                            <button
                                mat-icon-button
                                color="primary"
                                [disabled]="row.deleting"
                                (click)="deleteLink(row)"
                                [attr.aria-label]="'a11y.pdfMarkups.confirmDelete' | translate"
                                data-testid="nutrient-doc-link-row-confirm">
                                <mat-icon aria-hidden="true">check</mat-icon>
                            </button>
                            <button
                                mat-icon-button
                                [disabled]="row.deleting"
                                (click)="toggleDeleteLink(row)"
                                [attr.aria-label]="'a11y.pdfMarkups.cancel' | translate"
                                data-testid="nutrient-doc-link-row-cancel">
                                <mat-icon aria-hidden="true">close</mat-icon>
                            </button>
                        } @else if (data.canDelete) {
                            <button
                                mat-icon-button
                                color="warn"
                                (click)="toggleDeleteLink(row)"
                                [attr.aria-label]="'a11y.common.delete' | translate"
                                data-testid="nutrient-doc-link-row-delete">
                                <mat-icon aria-hidden="true">delete</mat-icon>
                            </button>
                        }
                    </td>
                </ng-container>

                <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
                <tr mat-row *matRowDef="let row; columns: displayedColumns" data-testid="nutrient-doc-link-row"></tr>
            </table>
        }
    }
</mat-dialog-content>

<mat-dialog-actions align="end">
    @if (isAddAssociation) {
        <button
            mat-raised-button
            color="primary"
            [disabled]="!documentControl.value || isSaving()"
            (click)="save()"
            data-testid="nutrient-doc-link-action-save">
            <mat-icon aria-hidden="true">check</mat-icon>
            {{ "general.save" | translate }}
        </button>
    }
    <button mat-raised-button (click)="close()" data-testid="nutrient-doc-link-action-close">
        {{ "general.close" | translate }}
    </button>
</mat-dialog-actions>
